;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Base/PictureAsBackground',["jquery", "picturefill", "score_bootstrap/Utils/window"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("picturefill"), require("score_bootstrap/Utils/window")) :
    console && console.error('PictureAsBackground does not support non-amd script loading.');
}(this/* window */, function ($, picturefill, global) {

    function PictureAsBackground($scope, picSelector, eePicSelector) {

        if (!this.$scope) { this.$scope = $scope; }
        this.picSelector = picSelector;
        this.eePicSelector = eePicSelector;

        // combination of a selector for the Published View HTML and a selector for the Experience Editor   
        this.allPicSelector = this.picSelector + "," + this.eePicSelector;
        // default image selector, looks into picture tag and find the default img
        this.defImgSelector = this.picSelector + " img," + this.eePicSelector + " img";

        // init picturefill for an old browser
        if (this.$scope.find(this.allPicSelector).length > 0) {
            picturefill({ context: this.$scope.find(this.allPicSelector).get(0) });
        }

        $(global).on('resize.score', this._resizeHandler.bind(this));
        this._updateBackgroundWhenImageLoaded();

        //#region Handle EE field update event.
        if (typeof Sitecore != typeof void 0 && typeof Sitecore.PageModes != typeof void 0 && Sitecore.PageModes != null && Sitecore.PageModes.PageEditor != null) {
            // wrap picture object into sitecore jQuery object, since SCORE use jQuery 3.x and Sitecore is on jQuery 1.x/2.x and they aren't compatable 
            var $scPicture = $sc(this.$scope.find(this.allPicSelector).get(0));

            var cId = Sitecore.PageModes.ChromeManager.getChrome($scPicture).controlId();
            var that = this;

            var originalHandleMessage = Sitecore.PageModes.ChromeTypes.Field.prototype.handleMessage;
            Sitecore.PageModes.ChromeTypes.Field.prototype.handleMessage = function (message, params, sender) {
                originalHandleMessage.call(this, message, params, sender);
                if (message === "chrome:field:editcontrolcompleted" && this.controlId() == cId) {
                    that._updateBackgroundWhenImageLoaded();
                }
            };
        }
        //#endregion EE handling end
    }

    PictureAsBackground.prototype.update = function () {
        var $img = this.$scope.find(this.defImgSelector);
        if (!$img.length) return;

        var img = $img.get(0);
        var src = img.currentSrc !== void 0 ? img.currentSrc : img.src;

        // image is not set, or was cleared.
        if (src.substr(-img.getAttribute('srcset').length) === img.getAttribute('srcset')) { // cannot use img.srcset because of IE11
            // clear background image
            this.$scope.css({ backgroundImage: "" });
            return;
        }

        // update background image for the parent only in case if it was changed, otherwise don't waste our time.
        if (this.$scope.css('backgroundImage') !== "url(" + src + ")") {
            this.$scope.css({ backgroundImage: "url(" + src + ")" });
        }
    }

    PictureAsBackground.prototype._resizeHandler = function () {
        this._updateBackgroundWhenImageLoaded();
    }

    PictureAsBackground.prototype._updateBackgroundWhenImageLoaded = function () {
        var $img = this.$scope.find(this.defImgSelector);
        if ($img.get(0).complete && $img.get(0).naturalHeight > 0) {
            // update background if image already loaded
            this.update();
        } else {
            // wait until a real picture image will be loaded, Otherwise we got default image (blank image).
            $img.on('load', this.update.bind(this));
        }
    }

    

    return PictureAsBackground;
}));
